import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Cars from "./pages/Cars";
import Booking from "./pages/Booking";
import About from "./pages/About";
import Contact from "./pages/Contact";

/* ROUTE WRAPPER FOR ANIMATION */
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div className="page-wrapper fade-page" key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

/* NAVBAR + ROUTER */
function Layout() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [navLoaded, setNavLoaded] = useState(false);

  useEffect(() => {
    setNavLoaded(true);

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <nav className={`glass-nav ${scrolled ? "shrink" : ""} ${navLoaded ? "nav-show" : ""}`}>
        {/* BRAND */}
        <div className="nav-brand">
          <span className="brand-icon"></span>
          <span className="brand-text">Cherry Self Drive Cars</span>
        </div>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        {/* LINKS */}
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/">Home</Link>
          <Link to="/cars">Cars</Link>
          <Link to="/booking">Booking</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>

          <a href="tel:09052885299" className="mobile-call">
            📞 Call Now
          </a>
        </div>

        {/* DESKTOP CALL */}
        <a href="tel:09052885299" className="call-btn">
          📞 Call Now <span>+919052885299</span>
        </a>
      </nav>

      <AnimatedRoutes />
    </>
  );
}

/* MAIN APP */
function App() {
  return (
    <BrowserRouter>
      <div className="app-bg">
        <Layout />
      </div>
    </BrowserRouter>
  );
}

export default App;
